import { render, staticRenderFns } from "./bilancorapor.vue?vue&type=template&id=787cb5aa"
import script from "./bilancorapor.vue?vue&type=script&lang=js"
export * from "./bilancorapor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports